import { render, staticRenderFns } from "./RewardRule.vue?vue&type=template&id=45bf7552"
import script from "./RewardRule.vue?vue&type=script&lang=js"
export * from "./RewardRule.vue?vue&type=script&lang=js"
import style0 from "./RewardRule.vue?vue&type=style&index=0&id=45bf7552&prod&lang=less"
import style1 from "./RewardRule.vue?vue&type=style&index=1&id=45bf7552&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports